import React, { useMemo } from 'react'
import { dividedRoomNumber } from '@/libs/divide-list'
import { Popover } from 'antd'
import { css } from '@emotion/core'
import { groupBy } from 'lodash'

type Room = {
  roomTypeId: string
  typeName: string
  roomNumber: string
}

type Prop = {
  rooms: Room[]
}

export const RoomNumberPopup: React.FC<Prop> = props => {
  const roomsByType = useMemo(() => groupBy(props.rooms, room => room.roomTypeId), [props.rooms])
  const isEnabledPopup = useMemo(() => props.rooms.length > 2, [props.rooms])

  const popupContent = () => {
    return (
      <div css={popupStyle}>
        {Object.keys(roomsByType).map(typeId => {
          return <div key={typeId}>{`${roomsByType[typeId][0].typeName} ${roomsByType[typeId].length}室`}</div>
        })}
      </div>
    )
  }

  const roomNumberContent = () => (
    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{dividedRoomNumber(props.rooms)}</div>
  )

  return (
    <>
      {isEnabledPopup ? (
        <>
          <style>{`
            .ant-popover-placement-bottom { padding-top: 0; }
            .ant-popover-arrow { display: none; }
          `}</style>
          <Popover content={popupContent()} placement="bottomLeft">
            {roomNumberContent()}
          </Popover>
        </>
      ) : (
        roomNumberContent()
      )}
    </>
  )
}

const popupStyle = css({
  color: '#676767',
  lineHeight: 1.5,
  fontSize: 12,
  fontWeight: 'bold',
  padding: '12px 16px',
})
